import { WEBVIEW_ERROR_MESSAGE } from '@/config/constants';
import { logError } from '@/utils/logHandling';
import { forwardRef } from 'react';
import { Alert, View } from 'react-native';
import { WebView as NativeWebView, WebViewProps } from 'react-native-webview';
import { styles } from './styles';

type WebViewComponentProps = {
  source: WebViewProps['source'];
  onLoadEnd: WebViewProps['onLoadEnd'];
};

export const WebView = forwardRef<NativeWebView, WebViewComponentProps>(
  (props: WebViewComponentProps, ref) => {
    const onError: WebViewProps['onError'] = (e) => {
      try {
        const { description } = e.nativeEvent;
        Alert.alert(WEBVIEW_ERROR_MESSAGE.onError);
        const customError = new Error(description);
        logError(WEBVIEW_ERROR_MESSAGE.onError, customError);
      } catch (error) {
        if (error instanceof Error) {
          logError(WEBVIEW_ERROR_MESSAGE.catchOnError, error);
        }
        Alert.alert('Fehler!', WEBVIEW_ERROR_MESSAGE.catchOnError);
      }
    };

    const onMessageError: WebViewProps['onMessage'] = (e) => {
      try {
        const { data } = e.nativeEvent;
        const { context, error } = JSON.parse(data) ?? {
          context: '',
          error: '',
        };
        Alert.alert(WEBVIEW_ERROR_MESSAGE.onMessage);
        const customError = new Error(`${error} (${context})`);
        logError(WEBVIEW_ERROR_MESSAGE.onError, customError);
      } catch (error) {
        if (error instanceof Error) {
          logError(WEBVIEW_ERROR_MESSAGE.onError, error);
        }
        Alert.alert('Fehler!', WEBVIEW_ERROR_MESSAGE.catchOnMessage);
      }
    };

    return (
      <View style={styles.fill}>
        <NativeWebView
          ref={ref}
          style={styles.fill}
          scrollEnabled
          originWhitelist={['*']}
          onError={onError}
          onMessage={onMessageError}
          onShouldStartLoadWithRequest={(request) => {
            // Only allow navigating the static file we provide for statistic display and not any webpages
            return request.url === 'about:blank';
          }}
          {...props}
        />
      </View>
    );
  },
);

WebView.displayName = 'WebView';
